import React from "react";
import Layout from "../components/Layout";
import { graphql } from "gatsby";
import "../components/main.scss";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import Nav from "../components/Nav";
import { Helmet } from "react-helmet";
import ScrollButton from "../components/ScrollButton";
const IndexPage = (props) => {
  console.log(props.data.Team);
  const imgAbout = getImage(props.data.AboutImg.childImageSharp);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>About</title>
        <meta
          name="description"
          content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        />
      </Helmet>
      <Layout>
        <Nav about="nav-active" />
        <header class="header">
          <div className="black-overlay">
            <div class="container1" style={{ width: "100%", height: "100%" }}>
              <div className="header-text">
                <p className="header-p">WE SALE FRESH FRUITS</p>
                <h1 className="header-h1">About us</h1>
              </div>
            </div>
          </div>
        </header>
        <section className="aboutpage-section-about">
          <h2 className="h2">
            Why <span>Fruitkha</span>
          </h2>
          <div className="container1">
            <div className="aboutpage-section-about-text">
              <ul>
                <li>
                  <div className="svg">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="truck-fast"
                      class="svg-inline--fa fa-truck-fast"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 512"
                    >
                      <path
                        fill="currentColor"
                        d="M64 48C64 21.49 85.49 0 112 0H368C394.5 0 416 21.49 416 48V256H608V352C625.7 352 640 366.3 640 384C640 401.7 625.7 416 608 416H576C576 469 533 512 480 512C426.1 512 384 469 384 416H256C256 469 213 512 160 512C106.1 512 64 469 64 416V288H208C216.8 288 224 280.8 224 272C224 263.2 216.8 256 208 256H16C7.164 256 0 248.8 0 240C0 231.2 7.164 224 16 224H240C248.8 224 256 216.8 256 208C256 199.2 248.8 192 240 192H48C39.16 192 32 184.8 32 176C32 167.2 39.16 160 48 160H272C280.8 160 288 152.8 288 144C288 135.2 280.8 128 272 128H16C7.164 128 0 120.8 0 112C0 103.2 7.164 96 16 96H64V48zM160 464C186.5 464 208 442.5 208 416C208 389.5 186.5 368 160 368C133.5 368 112 389.5 112 416C112 442.5 133.5 464 160 464zM480 368C453.5 368 432 389.5 432 416C432 442.5 453.5 464 480 464C506.5 464 528 442.5 528 416C528 389.5 506.5 368 480 368zM466.7 160H400V96H466.7C483.7 96 499.1 102.7 512 114.7L589.3 192C601.3 204 608 220.3 608 237.3V288H544V237.3L466.7 160z"
                      ></path>
                    </svg>
                  </div>
                  <div className="list-section-content">
                    <h3>Home Delivery</h3>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </p>
                  </div>
                </li>
                <li>
                  <div className="svg">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="money-bill"
                      class="svg-inline--fa fa-money-bill"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path
                        fill="currentColor"
                        d="M528 64h-480C21.49 64 0 85.49 0 112v288C0 426.5 21.49 448 48 448h480c26.51 0 48-21.49 48-48v-288C576 85.49 554.5 64 528 64zM48 400v-64c35.38 0 64 28.62 64 64H48zM48 176v-64h64C112 147.4 83.38 176 48 176zM288 352c-44.18 0-80-42.98-80-96c0-53.02 35.82-96 80-96s80 42.98 80 96C368 309 332.2 352 288 352zM528 400h-64c0-35.38 28.62-64 64-64V400zM528 176c-35.38 0-64-28.62-64-64h64V176z"
                      ></path>
                    </svg>
                  </div>
                  <div className="list-section-content">
                    <h3>Best Price</h3>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </p>
                  </div>
                </li>
                <li>
                  <div className="svg">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="briefcase"
                      class="svg-inline--fa fa-briefcase"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M320 336c0 8.844-7.156 16-16 16h-96C199.2 352 192 344.8 192 336V288H0v144C0 457.6 22.41 480 48 480h416c25.59 0 48-22.41 48-48V288h-192V336zM464 96H384V48C384 22.41 361.6 0 336 0h-160C150.4 0 128 22.41 128 48V96H48C22.41 96 0 118.4 0 144V256h512V144C512 118.4 489.6 96 464 96zM336 96h-160V48h160V96z"
                      ></path>
                    </svg>
                  </div>

                  <div className="list-section-content">
                    <h3>Custom Box</h3>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </p>
                  </div>
                </li>
                <li>
                  <div className="svg">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="rotate"
                      class="svg-inline--fa fa-rotate"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M449.9 39.96l-48.5 48.53C362.5 53.19 311.4 32 256 32C161.5 32 78.59 92.34 49.58 182.2c-5.438 16.81 3.797 34.88 20.61 40.28c16.97 5.5 34.86-3.812 40.3-20.59C130.9 138.5 189.4 96 256 96c37.96 0 73 14.18 100.2 37.8L311.1 178C295.1 194.8 306.8 223.4 330.4 224h146.9C487.7 223.7 496 215.3 496 204.9V59.04C496 34.99 466.9 22.95 449.9 39.96zM441.8 289.6c-16.94-5.438-34.88 3.812-40.3 20.59C381.1 373.5 322.6 416 256 416c-37.96 0-73-14.18-100.2-37.8L200 334C216.9 317.2 205.2 288.6 181.6 288H34.66C24.32 288.3 16 296.7 16 307.1v145.9c0 24.04 29.07 36.08 46.07 19.07l48.5-48.53C149.5 458.8 200.6 480 255.1 480c94.45 0 177.4-60.34 206.4-150.2C467.9 313 458.6 294.1 441.8 289.6z"
                      ></path>
                    </svg>
                  </div>

                  <div className="list-section-content">
                    <h3>Quick Refund</h3>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="aboutpage-section-about-img">
              <GatsbyImage image={imgAbout} alt="Fruits" />
            </div>
          </div>
        </section>
        <section className="homepage-section-owners">
          <div className="container1">
            <Carousel
              autoPlay={true}
              emulateTouch={true}
              showIndicators={true}
              showArrows={true}
              infiniteLoop={true}
            >
              {props.data.Owners.edges.map((el) => {
                const img = getImage(
                  el.node.frontmatter.featuredImage.childImageSharp
                );
                return (
                  <div>
                    <ul className="corusel-item">
                      <li>
                        <GatsbyImage image={img} />
                      </li>
                      <li>
                        <h3>
                          {el.node.frontmatter.featuredImage_alt}
                          <span>Local shop owner</span>
                        </h3>
                      </li>
                      <li>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Velit ut tortor pretium viverra
                          suspendisse potenti nullam ac tortor. Arcu risus quis
                          varius quam. Ipsum dolor sit amet consectetur
                          adipiscing elit. Nibh nisl condimentum id venenatis a
                          condimentum vitae sapien.
                        </p>
                      </li>
                      <li>
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="quote-right"
                          class="svg-inline--fa fa-quote-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                        >
                          <path
                            fill="currentColor"
                            d="M96 96C42.98 96 0 138.1 0 192s42.98 96 96 96c11.28 0 21.95-2.305 32-5.879V288c0 35.3-28.7 64-64 64c-17.67 0-32 14.33-32 32s14.33 32 32 32c70.58 0 128-57.42 128-128V192C192 138.1 149 96 96 96zM448 192c0-53.02-42.98-96-96-96s-96 42.98-96 96s42.98 96 96 96c11.28 0 21.95-2.305 32-5.879V288c0 35.3-28.7 64-64 64c-17.67 0-32 14.33-32 32s14.33 32 32 32c70.58 0 128-57.42 128-128V192z"
                          ></path>
                        </svg>
                      </li>
                    </ul>
                  </div>
                );
              })}
            </Carousel>
          </div>
        </section>
        <section className="team-section">
          <div className="container1">
            {props.data.Team.edges.map((el) => {
              const imgTeammate = getImage(
                el.node.frontmatter.featuredImage.childImageSharp
              );
              return (
                <div className="teammate-container">
                  <div className="teammate-image">
                    <GatsbyImage
                      image={imgTeammate}
                      alt={el.node.frontmatter.featuredImage_alt}
                    />
                    <ul>
                      <li>
                        <Link to="/">
                          <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fab"
                            data-icon="facebook-f"
                            class="svg-inline--fa fa-facebook-f"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                          >
                            <path
                              fill="currentColor"
                              d="M279.1 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.4 0 225.4 0c-73.22 0-121.1 44.38-121.1 124.7v70.62H22.89V288h81.39v224h100.2V288z"
                            ></path>
                          </svg>
                        </Link>
                      </li>
                      <li>
                        <Link to="/">
                          <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fab"
                            data-icon="twitter"
                            class="svg-inline--fa fa-twitter"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                          >
                            <path
                              fill="currentColor"
                              d="M459.4 151.7c.325 4.548 .325 9.097 .325 13.65 0 138.7-105.6 298.6-298.6 298.6-59.45 0-114.7-17.22-161.1-47.11 8.447 .974 16.57 1.299 25.34 1.299 49.06 0 94.21-16.57 130.3-44.83-46.13-.975-84.79-31.19-98.11-72.77 6.498 .974 12.99 1.624 19.82 1.624 9.421 0 18.84-1.3 27.61-3.573-48.08-9.747-84.14-51.98-84.14-102.1v-1.299c13.97 7.797 30.21 12.67 47.43 13.32-28.26-18.84-46.78-51.01-46.78-87.39 0-19.49 5.197-37.36 14.29-52.95 51.65 63.67 129.3 105.3 216.4 109.8-1.624-7.797-2.599-15.92-2.599-24.04 0-57.83 46.78-104.9 104.9-104.9 30.21 0 57.5 12.67 76.67 33.14 23.72-4.548 46.46-13.32 66.6-25.34-7.798 24.37-24.37 44.83-46.13 57.83 21.12-2.273 41.58-8.122 60.43-16.24-14.29 20.79-32.16 39.31-52.63 54.25z"
                            ></path>
                          </svg>
                        </Link>
                      </li>
                      <li>
                        <Link to="/">
                          <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fab"
                            data-icon="instagram"
                            class="svg-inline--fa fa-instagram"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                          >
                            <path
                              fill="currentColor"
                              d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                            ></path>
                          </svg>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <ul className="teammate-name">
                    <li>
                      <h4>{el.node.frontmatter.featuredImage_alt}</h4>
                    </li>
                    <li>
                      <p>Farmer</p>
                    </li>
                  </ul>
                </div>
              );
            })}
          </div>
        </section>
        <ScrollButton />
      </Layout>
    </>
  );
};

export default IndexPage;
export const query = graphql`
  query AboutPageQuery {
    Owners: allMdx(filter: { frontmatter: { title: { eq: "Owner" } } }) {
      edges {
        node {
          id
          frontmatter {
            featuredImage_alt
            featuredImage {
              childImageSharp {
                gatsbyImageData(width: 100)
              }
            }
          }
        }
      }
    }
    AboutImg: file(relativePath: { eq: "home/bg.jpg" }) {
      childImageSharp {
        gatsbyImageData(sizes: "540", width: 540)
      }
    }
    Team: allMdx(filter: { frontmatter: { title: { eq: "Farmer" } } }) {
      edges {
        node {
          id
          frontmatter {
            featuredImage {
              childImageSharp {
                gatsbyImageData(width: 510)
              }
            }
            featuredImage_alt
            title
          }
          body
        }
      }
    }
  }
`;
